(function ($) {
  Drupal.behaviors.carddeckCarouselFormatterV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-carddeck-carousel-formatter', context);

      $modules.each(function () {
        var $module = $(this);

        self.carouselInit($module);
      });
    },
    carouselInit: function ($module) {
      this.customCarouselSetup($module);
    },
    customCarouselSetup: function ($module) {
      var $carousel = $module.find('.js-carddeck-carousel-formatter__carousel');
      var $carouselTemplate = $module.find('.js-carddeck-carousel-formatter__carddeck');
      var $slides = $carouselTemplate.children().not('.js-carddeck-carousel-formatter__carddeck-arrowscontainer');
      var activeIndex = -1;
      var slideCount = $slides.length;

      this.createSlideClasses($slides, $carouselTemplate, slideCount);
      this.addDots($carousel, slideCount);
      this.setCarddeckListeners($slides, $carouselTemplate, activeIndex, slideCount);
    },
    createSlideClasses: function ($slides, $carouselTemplate, slideCount) {
      var $el;

      $slides.first().addClass('active');
      $slides.addClass('card_deck-slides');
      $carouselTemplate.children().not('.js-carddeck-carousel-formatter__carddeck-arrowscontainer').each(function (i, el) {
        $el = $(el);
        $el.addClass('card_deck-slides--' + String((slideCount - 1) - i));
        $carouselTemplate.prepend($el);
      });
    },
    addDots: function ($carousel, slideCount) {
      var $dotList = $carousel.find('.js-carddeck-carousel-formatter__dots-list');
      var i;

      if ($dotList.length > 0) {
        for (i = 0; i < slideCount; i++) {
          $dotList.append($('<li><button type="button" data-role="none">' + i + '</button></li>'));
        }
      }
      $($dotList.children()[0]).addClass('slick-active');
    },
    setCarddeckListeners: function ($slides, $carouselTemplate, activeIndex, slideCount) {
      var self = this;
      var $arrowsContainer = $carouselTemplate.find('.js-carddeck-carousel-formatter__carddeck-arrowscontainer');
      var $leftArrow = $arrowsContainer.find('.slick-prev');
      var $rightArrow = $arrowsContainer.find('.slick-next');
      var tempIndex = activeIndex;

      $leftArrow.off('click.left').on('click.left', function () {
        if (tempIndex >= 0) {
          self.clearClasses($carouselTemplate, slideCount);
          $rightArrow.addClass('active');
          self.disableArrows($leftArrow, $rightArrow);
          $arrowsContainer.removeClass('nudge-right').addClass('nudge-left');
          $($slides[tempIndex]).removeClass('opaque');
          $carouselTemplate.addClass('current-stage--' + tempIndex);
          setTimeout(function () {
            $($slides[tempIndex]).removeClass('ani-out ani-' + tempIndex);
            tempIndex--;
          }, 10);
          if (tempIndex < 0) {
            $leftArrow.removeClass('active');
          }
        } else {
          $leftArrow.removeClass('active');
        }
      });

      $rightArrow.off('click.right').on('click.right', function () {
        if (tempIndex < slideCount) {
          self.clearClasses($carouselTemplate, slideCount);
          $leftArrow.addClass('active');
          self.disableArrows($leftArrow, $rightArrow);
          tempIndex++;
          $carouselTemplate.addClass('current-stage--' + (tempIndex + 1));
          $arrowsContainer.removeClass('nudge-left').addClass('nudge-right');
          $($slides[tempIndex]).addClass('ani-out ani-' + tempIndex);
          setTimeout(function () {
            $($slides[tempIndex]).addClass('opaque');
          }, 251);
          if (tempIndex >= slideCount - 2) {
            $rightArrow.removeClass('active');
          }
        } else {
          $rightArrow.removeClass('active');
        }
      });
    },
    clearClasses: function ($carouselTemplate, slideCount) {
      var i;

      for (i = 0; i < slideCount; i++) {
        $carouselTemplate.removeClass('current-stage--' + i);
      }
    },
    disableArrows: function ($leftArrow, $rightArrow) {
      $leftArrow.attr('disabled', 'disabled');
      $rightArrow.attr('disabled', 'disabled');
      setTimeout(function () {
        $leftArrow.removeAttr('disabled');
        $rightArrow.removeAttr('disabled');
      }, 500);
    }

  };
})(jQuery);
